import {ADMIN_CONSIGNMENT_SUPPLIER_ENDPOINT, ADMIN_EXPORT_SUPPLIER_HISTORY_ENDPOINT, ADMIN_SUPPLIER_ENDPOINT, ADMIN_SUPPLIER_HISTORY_ENDPOINT} from '../../constants/endpoints'
import {PaginateModel} from '../../models/PaginateModel'
import axios from 'axios'
import {ResponseModel} from '../../models/ResponseModel'
import {SearchModel, SupplierModel} from '../../models/SupplierModel'

export function getList(params?: SearchModel) {
  return axios.get<PaginateModel<SupplierModel>>(`${ADMIN_CONSIGNMENT_SUPPLIER_ENDPOINT}/get-list`, {params})
}

export function store(supplier: SupplierModel) {
  return axios.post<ResponseModel>(ADMIN_CONSIGNMENT_SUPPLIER_ENDPOINT, supplier)
}

export function update(supplier: SupplierModel) {
  return axios.post<ResponseModel>(`${ADMIN_CONSIGNMENT_SUPPLIER_ENDPOINT}/${supplier.id}`, supplier)
}

export function remove(ids?: number[]) {
  return axios.delete<ResponseModel>(`${ADMIN_CONSIGNMENT_SUPPLIER_ENDPOINT}/destroy`, {params: {ids}})
}